import Vue from 'vue'
import {store} from '../../components/front/vue/store/store'
// import AuctionsList from 'FrontComponents/vue/AuctionsList/Index.vue'
// import UserBids from 'FrontComponents/vue/Account/UserBids.vue'
import VueLazyload from 'vue-lazyload'
import Lang from '~/lang'
import ReadMore from 'vue-read-more'
import PortalVue from 'portal-vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueLazyload, {
    adapter: {
        loaded({bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init}) {
            // do something here
            // example for call LoadedHandler
            el.classList.add('lazy-loaded')
        },
        loading(listender, Init) {
            //console.log('loading')
        },
        error(listender, Init) {
            //console.log('error')
        },
    },
})

Vue.use(ReadMore)
Vue.use(VueScrollTo)

Vue.filter('trans', (...args) => {
    return Lang.get(...args)
})

if (document.querySelector('#auction-listing')) {
    const AuctionsList = () => import(/* webpackChunkName: "assets/auctions-list" */ 'FrontComponents/vue/AuctionsList/Index.vue')

    Vue.config.productionTip = false
    let mixin = {

        methods: {
            route: route,
        },
    }

    Vue.component('pagination', require('laravel-vue-pagination'))

    new Vue({
        el: '#auction-listing',
        store,
        mixins: [mixin],
        components: {
            AuctionsList,
        },
    })
}

if (document.querySelector('#user-bids-listing')) {
    const UserBids = () => import(/* webpackChunkName: "assets/user-bids" */ 'FrontComponents/vue/Account/UserBids.vue')

    Vue.config.productionTip = false
    Vue.use(PortalVue)

    Vue.mixin({
        methods: {
            route: route,
        },
    })

    new Vue({
        el: '#user-bids-listing',
        store,
        components: {
            UserBids,
        },
    })
}
